/** Evento disparado após refresh do access token para realinhar o cronômetro de sessão ao `exp` do JWT. */
export const ACCESS_TOKEN_EXPIRY_SYNC_EVENT = 'swiftsoft:access-token-expiry' as const;

export type AccessTokenExpirySyncDetail = { expiresAtMs: number };

/** Lê o claim `exp` (segundos Unix) do JWT; retorna milissegundos no relógio do cliente. */
export function getAccessTokenExpiryMs(accessToken: string): number | null {
  try {
    const parts = accessToken.split('.');
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padLen = (4 - (base64.length % 4)) % 4;
    const padded = padLen ? `${base64}${'='.repeat(padLen)}` : base64;
    const payload = JSON.parse(atob(padded)) as { exp?: unknown };
    const exp = payload?.exp;
    if (typeof exp !== 'number' || !Number.isFinite(exp)) return null;
    return exp * 1000;
  } catch {
    return null;
  }
}
